/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RewardLog } from '../../models/reward-log';
import { UpdateRewardLogDto } from '../../models/update-reward-log-dto';

export interface RewardLogsControllerUpdate$Params {
  id: string;
      body: UpdateRewardLogDto
}

export function rewardLogsControllerUpdate(http: HttpClient, rootUrl: string, params: RewardLogsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<RewardLog>> {
  const rb = new RequestBuilder(rootUrl, rewardLogsControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RewardLog>;
    })
  );
}

rewardLogsControllerUpdate.PATH = '/reward-logs/{id}';
